import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table, Button, Container } from "react-bootstrap";
import Swal from "sweetalert2";

const Contacts = () => {
  const [contacts, setContacts] = useState([]);
  const apiUrl = process.env.REACT_APP_API_URL;

  // Fetch contacts from the API
  useEffect(() => {
    axios
      .get(`${apiUrl}/get-contacts`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        setContacts(response.data);
      })
      .catch((error) => {
        console.error("Error fetching contacts:", error);
        Swal.fire("Error", "Failed to fetch contacts", "error");
      });
  }, [apiUrl]);

  // Function to delete a contact
  const deleteContact = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This contact will be permanently deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${apiUrl}/delete-contact/${id}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          })
          .then((response) => {
            Swal.fire("Deleted!", response.data.message, "success");
            setContacts(contacts.filter((contact) => contact.id !== id)); // Remove deleted contact from state
          })
          .catch((error) => {
            console.error("Error deleting contact:", error);
            Swal.fire("Error", "Failed to delete contact", "error");
          });
      }
    });
  };

  return (
    <Container className="mt-4">
      <h3 className="mb-4">Contact List</h3>
      <Table
        bordered
        hover
        responsive
        className="text-center"
        style={{ backgroundColor: "aliceblue" }}
      >
        <thead className="table-primary">
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Email</th>
            <th>Subject</th>
            <th>Message</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {contacts.length > 0 ? (
            contacts.map((contact, index) => (
              <tr key={contact.id}>
                <td>{index + 1}</td>
                <td>{contact.name}</td>
                <td>{contact.email}</td>
                <td>{contact.subject}</td>
                <td>{contact.message}</td>
                <td>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => deleteContact(contact.id)}
                    className="fw-bold"
                  >
                    Delete
                  </Button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center">
                No contacts found
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </Container>
  );
};

export default Contacts;
